import {TransactionError} from '@/modules/Transactions/errors';
import {PasskeyError} from '@/services/passkey';

export const isWalletCancelError = (error: any) =>
  (error instanceof PasskeyError && error.status === 'USER_CANCELLED') ||
  (error instanceof TransactionError && error.status === 'USER_CANCELLED') ||
  // Those are errors code for canceling transactions in different external wallets I managed to catch
  error?.code === 5000 ||
  error?.cause?.code === 4001;
